import { useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'

import { useFieldValidation } from './Fields/config'
import RHFDatePickerInput from './Fields/RHFDatePickerInput'
import Input from './Fields/RHFInput'
import TextArea from './Fields/RHFTextArea'
import { useDefaultDatePickerMonthYear } from './Hooks/useDefaultDates'
import type { CreateNoteItemViewModel } from '../Create/models'
import type { PatchNoteItemViewModel } from '../Edit/models'

import Group from 'components/utils/Group'

interface Props {
  tripId: string
}

function NoteFields({ tripId }: Props) {
  const { required } = useFieldValidation()
  const intl = useIntl()
  const { register, watch } = useFormContext<
    CreateNoteItemViewModel | PatchNoteItemViewModel
  >()

  const { defaultMonth, defaultYear } = useDefaultDatePickerMonthYear({
    tripId,
  })

  const isSectionHeaderSelected = !!watch('isSectionHeader')

  const titleLabel = intl.formatMessage({
    id: 'Gh3xeqoWwQBeisHeIHe0',
    defaultMessage: 'Title',
    description: 'Form label for title field in note trip item editor',
  })

  const titlePlaceholder = intl.formatMessage({
    id: '4ARkqDJ1biJCrcA3_Ob8',
    defaultMessage: 'Add Title',
    description: 'Placeholder text for title input in note trip item editor',
  })

  const noteLabel = intl.formatMessage({
    id: 'lRr3NcH5mnMhbGZg5N0-',
    defaultMessage: 'Note',
    description: 'Form label for note content field in note trip item editor',
  })

  const notePlaceholder = intl.formatMessage({
    id: '8lL-HnK60ahgBfwDB2Vn',
    defaultMessage: 'Add note here',
    description: 'Input placeholder text for notes textarea field in the trip planner item editor modal',
  })

  const dateLabel = intl.formatMessage({
    id: 'LQRsbwZ0fQ5CUpn5oTER',
    defaultMessage: 'Date',
    description: 'Form label for date field in note trip item editor',
  })

  const selectDatePlaceholder = intl.formatMessage({
    id: 'KTr4HPcRBZs0xHPDmClP',
    defaultMessage: 'Select date',
    description: 'Placeholder text for date picker in note trip item editor',
  })

  return (
    <>
      <Input
        {...register('title', {
          required: isSectionHeaderSelected ? required : undefined,
        })}
        required={isSectionHeaderSelected}
        label={titleLabel}
        placeholder={titlePlaceholder}
      />

      <TextArea
        {...register('notes', { required })}
        required
        label={noteLabel}
        placeholder={notePlaceholder}
        resize="vertical"
        rows={4}
      />
      <Group direction="vertical" horizontalAlign="stretch" gap={16}>
        <RHFDatePickerInput
          name="startDate"
          label={dateLabel}
          required={isSectionHeaderSelected}
          defaultMonth={defaultMonth}
          defaultYear={defaultYear}
          placeholder={selectDatePlaceholder}
        />
      </Group>
    </>
  )
}

export default NoteFields
